import React from "react";
import { useHistory, useParams } from "react-router";
import { Stack } from "@mui/material";
import CardDeckCreator from "../../components/CardDeckCreator/CardDeckCreator";
import FrontPageLogo from "../../components/Logo/Logo";

export default function DeckEditorPage() {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  return (
    <Stack
      sx={{
        position: { xs: "relative", md: "auto" },
        height: { md: "100vh", xs: "" },
        minHeight: { md: 0, xs: "100vh" },
        overflow: { md: "auto", xs: "scroll" },
        alignItems: "center",
      }}
    >
      <Stack
        direction="column"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{
          height: "100%",
          flex: 1,
          overflowY: { md: "scroll", xs: "auto" },
          paddingBottom: "2em",
        }}
      >
        <FrontPageLogo
          sx={{
            height: { lg: "16vh", md: "16vh", xs: "16vh" },
            width: { lg: "30vw", md: "40vw", xs: "70vw" },
            marginTop: { lg: "0vh", md: "3vh", xs: "0vh" },
          }}
        />
        <CardDeckCreator
          deckId={id}
          goBack={() => history.push("/profile")}
        />
      </Stack>
    </Stack>
  );
}
